import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="pt-20">
      <Helmet>
        <title>Privacy Policy | Monimek</title>
        <meta name="description" content="Monimek's Privacy Policy. Learn how we protect your data and privacy when using our medical tourism services." />
        <link rel="canonical" href="https://www.monizmek.com/privacy-policy" />
      </Helmet>
      
      <section className="bg-white py-20 min-h-[70vh]">
        <div className="max-w-[800px] mx-auto px-6">
          <h1 className="text-4xl font-black text-[#0B3C5D] font-outfit mb-8">Privacy Policy</h1>
          <div className="prose prose-lg text-[#6B7280]">
            <p><strong>Last Updated:</strong> March 2026</p>
            <p>At Monimek, we take your privacy seriously. This Privacy Policy outlines how we collect, use, and protect your personal and medical information when you interact with our platform.</p>
            
            <h2 className="text-xl font-bold text-[#0B3C5D] mt-8 mb-4">1. Information We Collect</h2>
            <p>We collect information you provide directly to us when requesting a consultation, such as your name, email address, phone number, and any medical information or images you choose to share for assessment by our partner clinics.</p>
            
            <h2 className="text-xl font-bold text-[#0B3C5D] mt-8 mb-4">2. How We Use Your Information</h2>
            <p>Your information is used exclusively to:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Facilitate medical consultations with JCI-accredited clinics in Turkey.</li>
              <li>Provide you with accurate treatment plans and cost estimates.</li>
              <li>Coordinate your travel, accommodation, and medical appointments.</li>
            </ul>
            
            <h2 className="text-xl font-bold text-[#0B3C5D] mt-8 mb-4">3. Data Security and Sharing</h2>
            <p>We do not sell your personal data. We only share necessary medical information with the specific healthcare providers involved in your treatment quote. We implement industry-standard encryption and security measures to protect your data.</p>
            
            <h2 className="text-xl font-bold text-[#0B3C5D] mt-8 mb-4">4. Your Rights</h2>
            <p>You have the right to request access to, correction of, or deletion of your personal data at any time. To make a request, please contact us via our Contact page.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
